import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'semantic-ui-react'
import StaticInput from './StaticInput'

class CheckboxInput extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      checked: props.checked || false
    }

    // Bind events
    this.onChange = this.onChange.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // Bubble local change to parent
    if (prevState.checked !== this.state.checked) {
      if (_.isFunction(this.props.onChange)) {
        this.props.onChange(this.state.checked)
      }
    }

    // Bubble parent change to local
    if (prevProps.checked !== this.props.checked) {
      this.setState({
        checked: this.props.checked
      })
    }
  }

  onChange(event, data) {
    const checked = data.checked
    this.setState({
      checked
    })
  }

  render() {
    const { label, text, checked, onChange, error, smallPadding, ...props } = this.props
    return (
      <StaticInput
        label={label}
        content={
          <Checkbox
            label={text}
            checked={this.state.checked}
            onChange={this.onChange}
            {...props}
          />
        }
        error={error}
        smallPadding={smallPadding}
      />
    )
  }
}

CheckboxInput.propTypes = {
  label: PropTypes.string, // if missing, rendered without Form structure
  text: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  smallPadding: PropTypes.bool
}

export default CheckboxInput



// WEBPACK FOOTER //
// ./src/components/elements/forms/CheckboxInput.js